

export default {
  data() {
    return {
    };
  },
  methods: {
    onResize(val) {
      console.log(val);
    },
  },
  computed: {
    wrapHeight() {
      return `${this.$store.state.global.windowHeight - 90}px`;
    },
  },
  mounted() {
  },
};
